import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{staticClass:"next-button",attrs:{"color":"primary","disabled":_vm.disabled,"rounded":""},on:{"click":_vm.onClick}},[_c(VIcon,{attrs:{"large":""}},[_vm._v(" mdi-arrow-right ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }